import React from 'react';
import { useSelector } from 'react-redux';

import { ServiceColumnContainer } from '../../../containers/service-column-container';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const ServiceColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { serviceId } = returnConfiguration || {};

  if (!serviceId) {
    return '';
  }

  return <ServiceColumnContainer serviceId={serviceId} />;
};

export const Service = {
  getMessageDescriptor: () => messages.service,
  id: 'service',

  render: ({ fulfillmentId }) => {
    return <ServiceColumn fulfillmentId={fulfillmentId} />;
  },
};
